@import "../../../variables";
.root {
  display: block;
  width: 100%;
  color: $TextInput;
  font-size: 16px;
  font-weight: 400;
  border: 1px solid $Border;
  border-radius: 4px;
  text-align: left;
  padding: 8px 12px;
  box-shadow: none;
  box-sizing: border-box;

  &::placeholder {
    font-family: "Noto Sans JP"; //20230111
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0.05em;
    color: #e8e8e8;
    opacity: 1; /* Firefox */
  }

  &:focus-within {
    outline: 2px solid #041615;
  }
}
